import { get } from "lodash";
const defaultState = {
    fetching: false,
    error: false,
    status: 0,
    servererror: [],
    data: {},
    authenticated: false,
    message: "Your attempt was not successful, please contact our support"
}

export default function storageReducer(state = defaultState, action) {
    const { data = {}, response = {} } = get(action, "payload.data", {});
    switch (action.type) {
        case "FETCH_PROFILE_PENDING": {
            return {
                ...defaultState,
                fetching: true,
            }
        }
        case "FETCH_PROFILE_FULFILLED": {
            return {
                ...defaultState,
                data,
                fetching: false,
                status: 200,
            }
        }
        case "FETCH_PROFILE_REJECTED": {
            const { errors = false, detail = false } = get(response, "data", {})
            return {
                ...defaultState,
                fetching: false,
                status: 400,
                error: errors ? errors : (detail ? detail : defaultState["message"])
            }
        }
        default: {
            return state;
        }
    }
}